import { render, staticRenderFns } from "./QuestionnaireResult.vue?vue&type=template&id=fc67f66a&"
import script from "./QuestionnaireResult.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports